// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2oQ3K","left":"StickyBox_left__3G6Du","right":"StickyBox_right__CF5bM"};